module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/battle-payments-elite-reward-100.ef339126.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/battle-payments-elite-reward-100.png
// module id = 3778
// module chunks = 11